import React from "react";
import AddTaskIcon from "@mui/icons-material/AddTask";
export default function AddActivity(props) {
  return (
    <>
      <div className={`addActivity`} {...props}>
        <span style={{ fontSize: "1.2em" }}>افزودن فعالیت</span>
        <span>
          <AddTaskIcon
            style={{
              color: "#396863",
            }}
          />
        </span>
      </div>
    </>
  );
}
